import { render, staticRenderFns } from "./TextDaycounter.vue?vue&type=template&id=165d633a&scoped=true&"
import script from "./TextDaycounter.vue?vue&type=script&lang=js&"
export * from "./TextDaycounter.vue?vue&type=script&lang=js&"
import style0 from "./TextDaycounter.vue?vue&type=style&index=0&id=165d633a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165d633a",
  null
  
)

export default component.exports